import { render, staticRenderFns } from "./AgentReceiptList.vue?vue&type=template&id=5a897f38&scoped=true"
import script from "./AgentReceiptList.vue?vue&type=script&lang=js"
export * from "./AgentReceiptList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a897f38",
  null
  
)

export default component.exports